module.exports = __webpack_public_path__ + "img/white-cross.22f71fef.svg";